import { TileModel } from "../../Feed/models/TileModel";
import { format } from 'date-fns';

export default function RelatedBlogPostItem({ node }: TileModel) {
  const name = node.name.length > 30 ? `${node.name.substring(0, 29)}...` : node.name;
  const summary = node.properties['summary'].toString();
  const concatenatedSummary = summary.length > 80 ? `${summary.substring(0, 79)}...` : summary;
  const preTitle = [node.properties['author'], format(new Date(node.properties["postDate"]), 'MMM dd, yyyy')].filter(x => x.length > 0).join(' - ');

  return (
    <div>
      <a href={node.url}>
          <h6>{name}</h6>
          <p>{concatenatedSummary}</p>
          <span>{preTitle}</span>
          <span className="go"><i className="fa fa-angle-right" aria-hidden="true"></i></span>
      </a>
    </div>
  )
}